import React, { useEffect } from "react";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";

const LcaFilterLogic = ({
  selectedSubCategory,
  selectedItem,
  searchTerm,
  Lca,
  bwv,
  searchQuery,
  radius,
  setFinalProducts,
  setFinalBwv,
  activeTab,
  month,
  city,
}) => {
  const dispatch = useDispatch();
  const { hideSkipped, skippedAd } = useSelector((state) => state.lcAds);

  const filterBySubCategory = (products, vendors, subCategory, activeTab) => {
    let filteredProducts = [...products];
    let filteredVendors = [...vendors];
    if (subCategory) {
      filteredProducts = filteredProducts.filter((ads) => {
        if (subCategory.id === 63) {
          return activeTab === "Customers"
            ? ads.engagedCouple === 1
            : ads.engagedCouple === 0;
        } else {
          return (
            ads.subCategoryId === subCategory.id && ads.engagedCouple !== 1
          );
        }
      });
      filteredVendors = filteredVendors.filter((ads) => {
        if (subCategory.id === 63) {
          return vendors; // No filtering for vendors when id === 63
        } else {
          return ads.subCategoryId === subCategory.id;
        }
      });
    } else {
      filteredProducts = filteredProducts.filter(
        (product) => product.engagedCouple !== 1
      );
    }
    console.log(filteredVendors, "vendors-after-sub");
    console.log(filteredProducts, "products-after-sub");
    return { filteredProducts, filteredVendors };
  };

  const filterByItem = (products, vendors, selectedItem) => {
    let filteredProducts = [...products];
    let filteredVendors = [...vendors];
    console.log(selectedItem, "selectedItem");
    console.log(filteredProducts, "selectedItem-filteredProducts");
    console.log(filteredVendors, "selectedItem-filteredVendors");
    if (selectedItem) {
      filteredProducts = filteredProducts.filter((product) => {
        const subCatItemName =
          selectedItem.subCatItemName?.trim().toLowerCase() || "";
        const itemName = product.itemName?.trim().toLowerCase() || "";
        const subCategoryName =
          product.subCategoryName?.trim().toLowerCase() || "";
        const categoryName = product.categoryName?.trim().toLowerCase() || "";
        return (
          subCatItemName === itemName ||
          subCatItemName === subCategoryName ||
          subCatItemName === categoryName
        );
      });
      filteredVendors = filteredVendors.filter((vendor) => {
        const subCatItemName =
          selectedItem.subCatItemName?.trim().toLowerCase() || "";
        const itemName = vendor.itemName?.trim().toLowerCase() || "";
        const subCategoryName =
          vendor.subCategoryName?.trim().toLowerCase() || "";
        const categoryName = vendor.categoryName?.trim().toLowerCase() || "";
        return (
          subCatItemName === itemName ||
          subCatItemName === subCategoryName ||
          subCatItemName === categoryName
        );
      });
    }
    console.log(filteredVendors, "vendors-after-item");
    console.log(filteredProducts, "products-after-item");
    return { filteredProducts, filteredVendors };
  };

  const filterBySearchTerm = (products, vendors, searchTerm) => {
    let filteredProducts = [...products];
    let filteredVendors = [...vendors];
    if (searchTerm) {
      filteredProducts = filteredProducts.filter(
        (ad) =>
          ad.Zipcode &&
          ad.Zipcode.toLowerCase().includes(searchTerm.toLowerCase())
      );
      filteredVendors = filteredVendors.filter(
        (vendor) =>
          vendor.Zipcode &&
          vendor.Zipcode.toLowerCase().includes(searchTerm.toLowerCase())
      );
    }
    console.log(filteredVendors, "vendors-after-zipcode");
    console.log(filteredProducts, "products-after-zipcode");
    return { filteredProducts, filteredVendors };
  };

  const filterBySearchQuery = (products, vendors, searchQuery) => {
    let filteredProducts = [...products];
    let filteredVendors = [...vendors];
    if (searchQuery) {
      const searchQueryLower = searchQuery.trim().toLowerCase();
      filteredProducts = filteredProducts.filter((product) => {
        const itemName = product.itemName?.trim().toLowerCase() || "";
        const subCategoryName =
          product.subCategoryName?.trim().toLowerCase() || "";
        const categoryName = product.categoryName?.trim().toLowerCase() || "";
        const titleMatch = product.Title?.trim().toLowerCase() || "";
        const fullNameMatch = product.FullName?.trim().toLowerCase() || "";
        const descriptionMatch =
          product.Description?.trim().toLowerCase() || "";
        const zipcodeMatch =
          String(product.Zipcode)?.trim().toLowerCase() || "";
        return (
          itemName.includes(searchQueryLower) ||
          subCategoryName.includes(searchQueryLower) ||
          categoryName.includes(searchQueryLower) ||
          titleMatch.includes(searchQueryLower) ||
          fullNameMatch.includes(searchQueryLower) ||
          descriptionMatch.includes(searchQueryLower) ||
          zipcodeMatch.includes(searchQueryLower)
        );
      });
      filteredVendors = filteredVendors.filter((vendor) => {
        const itemName = vendor.itemName?.trim().toLowerCase() || "";
        const subCategoryName =
          vendor.subCategoryName?.trim().toLowerCase() || "";
        const categoryName = vendor.categoryName?.trim().toLowerCase() || "";
        const listNameMatch = vendor.listName?.trim().toLowerCase() || "";
        const descMatch = vendor.Description?.trim().toLowerCase() || "";
        const locationMatch = vendor.Location?.trim().toLowerCase() || "";
        return (
          itemName.includes(searchQueryLower) ||
          subCategoryName.includes(searchQueryLower) ||
          categoryName.includes(searchQueryLower) ||
          listNameMatch.includes(searchQueryLower) ||
          descMatch.includes(searchQueryLower) ||
          locationMatch.includes(searchQueryLower)
        );
      });
    }
    console.log(filteredVendors, "vendors-after-searchQuery");
    console.log(filteredProducts, "products-after-searchQuery");
    return { filteredProducts, filteredVendors };
  };

  const filterByCity = (products, vendors, city) => {
    let filteredProducts = [...products];
    let filteredVendors = [...vendors];
    if (city) {
      const trimmedCity = city.trim().toLowerCase();
      filteredProducts = filteredProducts.filter((product) => {
        const cityMatch = product.placeName?.trim().toLowerCase() || "";
        return cityMatch === trimmedCity;
      });
      filteredVendors = filteredVendors.filter((vendor) => {
        const cityMatch = vendor.placeName?.trim().toLowerCase() || "";
        return cityMatch === trimmedCity;
      });
    }
    console.log(filteredVendors, "vendors-after-city");
    console.log(filteredProducts, "products-after-city");
    return { filteredProducts, filteredVendors };
  };

  const filterByMonth = (products, vendors, month) => {
    let filteredProducts = [...products];
    let filteredVendors = [...vendors];
    if (month) {
      filteredProducts = filteredProducts.filter((product) => {
        let eventDetails = [];
        try {
          eventDetails = Array.isArray(product.eventDetails)
            ? product.eventDetails
            : JSON.parse(product.eventDetails || "[]");
        } catch (error) {
          console.error("Error parsing eventDetails", error);
          return false;
        }

        const validEventDetails = eventDetails.filter(
          (event) =>
            event &&
            event.eventDate &&
            event.eventTime &&
            event.eventType &&
            event.eventLocation &&
            event.totalGuestCount
        );

        if (validEventDetails.length === 0) return false;

        return validEventDetails.some((event) => {
          const eventDate = new Date(event.eventDate);
          if (isNaN(eventDate.getTime())) return false;
          const eventMonth = `${eventDate.getFullYear()}-${String(
            eventDate.getMonth() + 1
          ).padStart(2, "0")}`;
          return eventMonth === month;
        });
      });
      // No month filtering for vendors, as per original code
    }
    console.log(filteredVendors, "vendors-after-month");
    console.log(filteredProducts, "products-after-month");
    return { filteredProducts, filteredVendors };
  };

  const filterRadius = async (products, vendors, radius, searchTerm) => {
    const newRadius = radius[1] * 1.60934; // Convert miles to kilometers
    const apiKey = process.env.REACT_APP_ZIPCODEBASE_KEY;
    const baseUrl = process.env.REACT_APP_ZIPCODEBASE_URL;
    const zipCode =
      searchTerm.length === 5 || searchTerm.length === 6 ? searchTerm : null;

    if (!zipCode)
      return { filteredProducts: products, filteredVendors: vendors };

    const url = `${baseUrl}?apikey=${apiKey}&code=${zipCode}&radius=${newRadius}&country=us`;

    try {
      const response = await axios.get(url);
      const resultVal = response.data;
      if (!resultVal.results.error) {
        const zipcodes = resultVal.results.map((dataval) => dataval.code);
        console.log(zipcodes, "zipcodes-after-radius");
        const filteredProducts = products.filter((ad) =>
          zipcodes.includes(ad.Zipcode)
        );
        const filteredVendors = vendors.filter((ad) =>
          zipcodes.includes(ad.Zipcode)
        );
        console.log(filteredVendors, "vendors-after-radius");
        console.log(filteredProducts, "products-after-radius");
        return { filteredProducts, filteredVendors };
      }
      return { filteredProducts: products, filteredVendors: vendors };
    } catch (error) {
      console.error("Error fetching zip codes:", error);
      return { filteredProducts: products, filteredVendors: vendors };
    }
  };

  const filterBySkipped = (products, vendors, hideSkipped) => {
    let filteredProducts = [...products];
    let filteredVendors = [...vendors];
    if (hideSkipped) {
      filteredProducts = filteredProducts.filter(
        (product) => product.needSkipCustomer !== 1
      );
      filteredVendors = filteredVendors;
    }
    return { filteredProducts, filteredVendors };
  };

  useEffect(() => {
    const applyFilters = async () => {
      let products = [...Lca];
      let vendors = [...bwv];

      if (!selectedSubCategory) {
        products = products.filter((product) => product.engagedCouple !== 1);
      }
      console.log(products, "products-after-initial");
      console.log(vendors, "vendors-after-initial");

      let result;

      // Apply subCategory filter
      result = filterBySubCategory(
        products,
        vendors,
        selectedSubCategory,
        activeTab
      );
      products = result.filteredProducts;
      vendors = result.filteredVendors;

      // Apply item filter
      result = filterByItem(products, vendors, selectedItem);
      products = result.filteredProducts;
      vendors = result.filteredVendors;

      // Apply searchQuery filter
      result = filterBySearchQuery(products, vendors, searchQuery);
      products = result.filteredProducts;
      vendors = result.filteredVendors;

      // Apply city filter
      result = filterByCity(products, vendors, city);
      products = result.filteredProducts;
      vendors = result.filteredVendors;

      // Apply month filter
      result = filterByMonth(products, vendors, month);
      products = result.filteredProducts;
      vendors = result.filteredVendors;

      // Apply skip filter
      result = filterBySkipped(products, vendors, hideSkipped);
      products = result.filteredProducts;
      vendors = result.filteredVendors;

      // Apply zipcode or radius filter (mutually exclusive)
      if (radius) {
        result = await filterRadius(products, vendors, radius, searchTerm);
        products = result.filteredProducts;
        vendors = result.filteredVendors;
      } else if (searchTerm) {
        result = filterBySearchTerm(products, vendors, searchTerm);
        products = result.filteredProducts;
        vendors = result.filteredVendors;
      }

      dispatch(setFinalProducts(products));
      dispatch(setFinalBwv(vendors));
      console.log(products, "products-after-all-filters");
      console.log(vendors, "vendors-after-all-filters");

      // const totalCount =
      //   selectedSubCategory?.id === 63 && activeTab === "Customers"
      //     ? products.length
      //     : products.length + vendors.length;
      // dispatch(setTotalCount(totalCount));
    };
    console.log(Lca, "234565432");
    applyFilters();
  }, [
    selectedSubCategory,
    selectedItem,
    searchTerm,
    Lca,
    bwv,
    searchQuery,
    radius,
    activeTab,
    month,
    city,
    hideSkipped,
    skippedAd,
    dispatch,
  ]);

  return null;
};

export default LcaFilterLogic;
